import defaultPosition from "@/helpers/wc/positionSettings";

export const graveyardSettings = {
  title: 'Graveyard',
  name: 'graveyardBase',

  styles: defaultPosition,

  properties: {
    cemeteryNo: "01",
    scale: 1,
    entrance: 1,
    css: {
      path: {
        strokeWidth: 4,
        stroke: 'burlywood'
      },
      text: {
        fontFamily: "Arial",
        fontSize: '40px',
        stroke: 'black',
        fill: 'black'
      },
      origin: {
        stroke: 'red'
      }
    }
  },
  cssLegend: {
    path: {
      name: 'path',
      strokeWidth: {
        type: 'int',
        name: 'width'
      },
      stroke: {
        type: 'color',
        name: 'color'
      },
    },
    text: {
      name: 'wcText',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      stroke: {
        type: 'color',
        name: 'strokeColor'
      },
      fill: {
        type: 'color',
        name: 'fillColor'
      }
    },
    origin: {
      name: 'originDevOnly',
      stroke: {
        type: 'color',
        name: 'color'
      }
    }
  }
};
